export const exchangeRates = {
    "USD": 1,
    "PKR": 280,
    "EUR": 0.84,
    "GBP": 0.73,
    "INR": 90.30,
    "AED": 3.67,
    "SAR": 3.75,
    "JPY": 153.08,
    "CAD": 1.35,
    "CNY": 6.90,
    "AUD": 1.40,
    "CHF": 0.77,
    "TRY": 30.50,
    "BDN": 105,
    "KWD": 0.31,
    "QAR": 3.64,
    "OMR": 0.38,
    "BHD": 0.38,
    "EGP": 31.00,
    "MYR": 3.92,
    "SGD": 1.27,
    "NZD": 1.66
};
